import { getProject } from '@gonfalon/openapi/operations/getProject';

import { createQueryOptions } from '../internal/createQueryOptions';

export const projectsDetail = createQueryOptions(getProject);
